import { ExamCenterProctorRequestType } from '@exam-center/graphql';
import { zodResolver, type PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { ProctorRequestCreationFormSchema, type ProctorRequestCreationFormInput } from './schemas';

type ProctorRequestCreationFormProviderProps = PropsWithChildren;

export default function ProctorRequestCreationFormProvider(
  props: Readonly<ProctorRequestCreationFormProviderProps>,
) {
  const { children } = props;

  const formContext = useForm<ProctorRequestCreationFormInput>({
    resolver: zodResolver(ProctorRequestCreationFormSchema),
    defaultValues: {
      proctorType: ExamCenterProctorRequestType.Proctor_1,
      personal: {
        idNumber: '',
        titleTh: null,
        firstNameTh: '',
        lastNameTh: '',
        titleEn: null,
        firstNameEn: '',
        lastNameEn: '',
        email: '',
        phoneNumber: '',
        address: '',
      },
      employeeInfo: {
        code: '',
        position: '',
        department: '',
        startedAt: undefined,
        termination: { isAssigned: 'false', endedAt: null },
      },
      document: {
        agreementForms: [],
        identifications: [],
      },
    } as unknown as ProctorRequestCreationFormInput,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
